'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('./shared/index.js');

var formConfigs = index;

exports.formConfigs = formConfigs;
